export default function displayFlash(notice, delay = 3000) {
  const template = document.querySelector('#flash-template');
  const clone = template.content.cloneNode(true);
  clone.querySelector('.flash-message').textContent = notice;
  clone.querySelector('.flash').dataset.flashTimeoutValue = delay;
  document.querySelector('#flashes').appendChild(clone);
}
